import { render, staticRenderFns } from "./biology.vue?vue&type=template&id=43c319fe&scoped=true&"
import script from "./biology.vue?vue&type=script&lang=js&"
export * from "./biology.vue?vue&type=script&lang=js&"
import style0 from "./biology.vue?vue&type=style&index=0&id=43c319fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43c319fe",
  null
  
)

export default component.exports